import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Navbar from './components/Navbar';
import ReporteAvisos from './pages/ReporteAvisos';
import ComparativaVentas from './pages/ComparativaVentas';
import Dashboard from './pages/Dashboard';
import EvolucionClientes from './pages/EvolucionClientes';
import CrearUsuario from './components/CrearUsuario';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { setupAxiosInterceptors, isAdmin } from './services/authService';
import GestionUsuarios from './pages/GestionUsuarios';

function App() {
  // Configurar interceptores de Axios al cargar la aplicación
  useEffect(() => {
    setupAxiosInterceptors();
  }, []);
  
  return (
    <Router>
      <Routes>
        {/* Ruta pública para login */}
        <Route path="/login" element={<Login />} />
        
        {/* Rutas protegidas */}
        <Route path="/" element={
          <ProtectedRoute>
            <Navbar />
            <main>
              <ReporteAvisos />
            </main>
          </ProtectedRoute>
        } />
        
        <Route path="/comparativa-ventas" element={
          <ProtectedRoute>
            <Navbar />
            <main>
              <ComparativaVentas />
            </main>
          </ProtectedRoute>
        } />
        
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Navbar />
            <main>
              <Dashboard />
            </main>
          </ProtectedRoute>
        } />
        
        <Route path="/evolucion-clientes" element={
          <ProtectedRoute>
            <Navbar />
            <main>
              <EvolucionClientes />
            </main>
          </ProtectedRoute>
        } />
        
        <Route path="/crear-usuario" element={
          <ProtectedRoute>
            <Navbar />
            <main>
              {isAdmin() ? <CrearUsuario /> : <Navigate to="/dashboard" replace />}
            </main>
          </ProtectedRoute>
        } />
        
        <Route path="/gestion-usuarios" element={
          <ProtectedRoute>
            <Navbar />
            <main>
              {isAdmin() ? <GestionUsuarios /> : <Navigate to="/dashboard" replace />}
            </main>
          </ProtectedRoute>
        } />
        
        {/* Redireccionar rutas desconocidas al dashboard */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App; 